<template>
  <div>
        <!-- 10.06 탭 안쪽으로 이동 -->
        <div class="mapping-selector d-flex justify-end">
          <div class="d-flex align-center">
            <p>{{$t('Normal Group')}}</p>
            <v-select
              outlined dense hide-details solo
              :placeholder="`${$t('Choose the group')}`"
              v-model="selectedGroup"
              :items="groupItems"
              item-text="groupName"
              item-value="groupName"
              class="form-select ml-2"
            ></v-select>
          </div>
        </div>
        <!-- //10.06 탭 안쪽으로 이동 -->

        <!-- data table -->
        <!-- <v-data-table
          v-model="selectedRow"
          :headers="templateMappingHeaders"
          :items="tableItems"
          :page.sync="page"
          :hide-default-footer="true"
          :items-per-page="-1"
          item-key="priority"
          show-select
          fixed-header
          height="528"
          class="tbl-type01"
        >
          <template slot="no-data">
            <p>
              {{ $t('No data available') }}
            </p>
          </template>
        </v-data-table> -->
        <!-- Multi Condition Mapping -->
        <v-data-table
        v-model="selectedRow"
        :headers="newTemplateMappingHeaders"
        :items="newTableItems"
        item-key="priority"
        show-select
        fixed-header
        height="528"
        class="tbl-type01"
        show-expand
        single-select
        :expanded.sync="expanded"
        :items-per-page="-1"
        @click:row="openEditDialog"
        hide-default-footer
        >
          <template slot="no-data">
            <p>
              {{ $t('No data available') }}
            </p>
          </template>
          <template v-slot:item.data-table-expand="{isExpanded, expand, item }">
            <!-- <v-btn  v-if="item.isExpandable" @click="expand(!isExpanded)" icon >
              <v-icon v-if="isExpanded"> mdi-chevron-down </v-icon>
              <v-icon v-else> mdi-chevron-up </v-icon>
            </v-btn>
          </template> -->
            <v-btn  v-if="item.isExpandable" @click="openViewDialog(item)" icon >
              <v-icon> mdi-information </v-icon>
            </v-btn>
          </template>
          <template v-slot:expanded-item="{ item, headers }">
            <td :colspan="headers.length" class="pa-0"  >
              <div class="d-flex"
                v-for="(condition, index) in item.otherConditions"
                :key="condition.conField + index">
                <div class="text-start expanded-td" :style="{width: '51px'}"></div>
                <div class="text-start expanded-td"
                  v-for="(value, index) in Object.values(condition)"
                  :key="index*2"
                  :style="{width: '13.6%'}">
                    {{value}}
                </div>
                <div class="text-start expanded-td" :style="{width: '68px'}"></div>
              </div>
            </td>
          </template>
        </v-data-table>
        <!-- 10.06 버튼 탭 안쪽으로 이동 -->
        <div class="innerButton">
          <!-- paging -->
          <!-- <div class="pageInfo">{{ pageInfoText }}</div> -->

          <div class="mt-2 mb-2">
            <v-btn text @click="moveCondPriority('start')" icon><img src="@/assets/img/ico-move-top.png"  alt=""></v-btn>
            <v-btn text @click="moveCondPriority('up')" icon><img src="@/assets/img/ico-move-up.png"  alt=""></v-btn>
            <v-btn text @click="moveCondPriority('down')" icon><img src="@/assets/img/ico-move-down.png"  alt=""></v-btn>
            <v-btn text @click="moveCondPriority('end')" icon><img src="@/assets/img/ico-move-bottom.png"  alt=""></v-btn>
          </div>
          <!-- // End of Multi Condition Mapping -->
         <!-- <v-dialog
            v-model="dialogSave"
            @click:outside="closeModal"
            width="400"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn text :disabled="buttonDisabled" v-bind="attrs" v-on="on" class="btn">{{$t('New')}}</v-btn>
            </template>

            <v-card class="popup add_store_popup">
              <h3 class="page-title-bar"><i class="ico ico-template"></i>{{$t('NEW MAPPING')}}</h3>
              <v-row>
                <v-col>
                  <v-text-field outlined dense hide-details
                    label="Mapping Title"
                    placeholder="Input the mapping title"
                    v-model="SaveCondition.tartgetField"
                    class="form-input"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <v-select
                    outlined dense hide-details
                    :label="`${$t('Target Field')}`"
                    :placeholder="`${$t('Select the target field')}`"
                    v-model="SaveCondition.tartgetField"
                    ref="tartgetField"
                    :items="targetFieldItems"
                    class="form-select"
                    clearable
                    @keydown="clearTabindex"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field outlined dense hide-details
                    :label="`${$t('Expected Value')}`"
                    :placeholder="`${$t('Input the expected value')}`"
                    v-model="SaveCondition.expectedValue"
                    ref="expectedValue"
                    class="form-input"
                    clearable
                    @keydown="clearTabindex"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>

                  <v-text-field outlined dense hide-details
                    label="Template Group"
                    placeholder="Input template group"
                    v-model="SaveCondition.linkedTemplateGroup"
                    class="form-input ico-search"
                  >
                  <v-select
                    outlined dense hide-details
                    :label="`${$t('Template Group')}`"
                    :placeholder="`${$t('Template Group')}`"
                    v-model="SaveCondition.linkedTemplateGroup"
                    :items="groupItems"
                    item-text="groupName"
                    item-value="groupName"
                    ref="linkedTemplateGroup"
                    class="form-select"
                    clearable
                    @keydown="clearTabindex"
                  ></v-select>

                  <template v-slot:append>
                    <img width="24" height="24" src="@/assets/img/ico-upload-file.gif" >
                  </template>
                  </v-text-field>

                </v-col>
              </v-row>

              <v-card-actions class="d-flex justify-center">
                <v-btn text icon @click="addNewCondition()" class="btn">{{ $t('Save') }}</v-btn>
                <v-btn text icon @click="dialogSave = false" class="btn">{{ $t('Cancel') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog> -->

      <!-- //For Multi Condition Mapping -->
      <v-dialog v-model="dialogSave" @click:outside="closeModal" width="1250">
        <template v-slot:activator="{ on, attrs }">
          <v-btn text :disabled="buttonDisabled" v-bind="attrs" v-on="on" @click="onClickNewTemplateCondition" class="btn">{{ $t('New') }}</v-btn>
        </template>
        <v-card class="popup add_store_popup">
          <h3 class="page-title-bar"><i class="ico ico-template"></i>{{ disableDialogFields ? $t('VIEW MAPPING') : isEditDialog ? $t('EDIT MAPPING') :  $t('NEW MAPPING') }}</h3>
          <div v-for="(condition, index) in SaveMultiCondition" :key="index">
            <v-row>
              <v-col cols="auto" style="max-width: 210px;">
                <v-select outlined dense hide-details :label="`${$t('Condition Field')}`"
                  :placeholder="`${$t('Select ConField')}`" v-model="condition.ConditionField" :disabled="disableDialogFields" :items="targetFieldItems"
                  class="form-select" clearable @keydown="clearTabindex">
                </v-select>
              </v-col>
              <v-col cols="auto" style="max-width: 180px;">
                <v-select outlined dense hide-details :label="`${$t('Condition Symbol')}`"
                  :placeholder="`${$t('Select ConSymbol')}`" v-model="condition.ConditionSymbol"  :disabled="disableDialogFields"  :items="ConSymbol"
                  class="form-select" clearable @keydown="clearTabindex"></v-select>
              </v-col>
              <v-col cols="auto" style="max-width: 210px;">
                <v-select outlined dense hide-details :label="`${$t('Condition Field Compare')}`"
                 :disabled="disableDialogFields"
                  :placeholder="`${$t('Select ConField Compare')}`" v-model="condition.ConditionFieldCompare"
                  :items="ConFieldCompare" class="form-select" clearable @keydown="clearTabindex"></v-select>
              </v-col>
              <v-col cols="auto" v-if="condition.ConditionFieldCompare === 'user-value'" style="max-width: 210px;">
                <v-text-field outlined dense hide-details :label="`${$t('Condition Text ')}`"
                 :disabled="disableDialogFields"
                  :placeholder="`${$t('Input ConText')}`" v-model="condition.ConText" class="form-input" clearable
                  @keydown="clearTabindex"></v-text-field>
              </v-col>
              <v-col cols="auto" style="max-width: 180px;">
                <v-select outlined dense hide-details :label="`${$t('Deciding Field')}`"
                  :placeholder="`${$t('Select decidingField')}`" v-model="condition.decidingField"  :disabled="disableDialogFields"  :items="decidingField"
                  class="form-select" clearable @keydown="clearTabindex"></v-select>
              </v-col>

              <v-col cols="auto" style="max-width: 150px;">
                <v-select outlined dense hide-details :label="`${$t('Condition Field Type')}`"
                  :placeholder="`${$t('Select ConField Type')}`" v-model="condition.ConditionFieldType"
                  :items="ConFieldType" class="form-select"
                   :disabled="disableDialogFields"
                  @change="handleConditionFieldTypeChange(condition, index)" @keydown="clearTabindex"></v-select>
              </v-col>
              <v-col cols="auto" v-if="condition.ConditionFieldType === 'END'" style="max-width: 210px;">
                <v-select outlined dense hide-details :label="`${$t('Template Group')}`"
                  :placeholder="`${$t('Template Group')}`" v-model="condition.linkedTemplateGroup" :items="groupItems"
                   :disabled="disableDialogFields"
                  item-text="groupName" item-value="groupName" class="form-select" clearable
                  @keydown="clearTabindex"></v-select>
              </v-col>
              <!-- <v-col cols="auto" style="display: flex;margin-top: 25px;max-width: 30px;align-items: center;"
                v-if="!condition.showMinusIcon && condition.ConditionFieldType === 'END'">
                <v-icon style="color:#001e38 ;" @click="addConditionRow(condition)">mdi-plus-circle</v-icon>
              </v-col>
              <v-col cols="auto" style="display: flex;margin-top: 25px;max-width: 30px;align-items: center;"
                v-if="condition.showMinusIcon && condition.ConditionFieldType === 'END'">
                <v-icon style="color:#001e38 ;" @click="removeConditionRow(index)">mdi-minus-circle</v-icon>
              </v-col> -->
            </v-row>
          </div>

          <v-card-actions v-if="!disableDialogFields" class="d-flex justify-center">
            <v-btn v-if="isEditDialog" text icon @click="editCondition()" class="btn">{{ $t('Save') }}</v-btn>
            <v-btn v-else text icon @click="addNewCondition()" class="btn">{{ $t('Save') }}</v-btn>
            <v-btn text icon @click="dialogSave = false" class="btn">{{ $t('Cancel') }}</v-btn>
          </v-card-actions>
          <v-card-actions v-else class="d-flex justify-center">
            <v-btn text icon @click="dialogSave = false;disableDialogFields=false;" class="btn">{{ $t('Close') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- // End of Multi Condition Mapping -->

          <v-btn text :disabled="deleteDisabled" class="btn ml-1" @click="RemoveMultiRow()" >{{$t('Delete')}}</v-btn>
          <v-btn text :disabled="buttonDisabled" class="btn ml-1" @click="multiConSave()">{{$t('Save')}}</v-btn>
        </div>
      </div>
</template>
<script>
import EventBus from '@/plugins/eventBus.js'
import commons from '@/plugins/commons'

export default {
  props: {
    tapNumber: Number,
    buttonDisabled: Boolean
  },
  // computed: {
  //   templateMappingHeaders () {
  //     return [
  //       { text: this.$t('PRIORITY'), value: 'priority', sortable: false },
  //       { text: this.$t('TARGET FIELD'), value: 'tartgetField', sortable: false },
  //       { text: this.$t('EXPECTED VALUE'), value: 'expectedValue', sortable: false },
  //       { text: this.$t('LINKED TEMPLATE GROUP'), value: 'linkedTemplateGroup', sortable: false }
  //     ]
  //   }
  // },
  watch: {
    selectedRow () {
      this.deleteDisabled = (commons.isNull(this.selectedRow) || this.selectedRow.length < 1 || this.buttonDisabled)
    },
    dialogSave (value) {
      if (value) {
        this.initAddPopup()
      }
    }
  },
  methods: {
    // Multi Condition Mapping
    onClickNewTemplateCondition () {
      this.isEditDialog = false
      this.disableDialogFields = false
      this.SaveMultiCondition = [{
        page: this.tapNumber,
        ConditionField: '',
        ConditionSymbol: '',
        ConditionFieldCompare: '',
        ConText: '',
        decidingField: '',
        ConditionFieldType: 'END',
        linkedTemplateGroup: '',
        addedNewRow: false,
        showMinusIcon: false
      }]
    },
    addConditionRow (existingCondition, index) {
      this.SaveMultiCondition.push({
        ConditionField: null,
        ConditionSymbol: null,
        ConditionFieldCompare: null,
        ConText: '',
        decidingField: '',
        ConditionFieldType: 'END',
        linkedTemplateGroup: null,
        addedNewRow: false,
        showMinusIcon: false // Show minus icon for the new row
      })
      existingCondition.addedNewRow = true
      if (existingCondition.ConditionFieldType === 'END') {
        existingCondition.showMinusIcon = true
      }
      // existingCondition.showMinusIcon = false // Hide plus icon for the existing row
    },
    removeConditionRow (index) {
      while (index !== this.SaveMultiCondition.length - 1) {
        this.SaveMultiCondition.pop()
      }
      this.SaveMultiCondition[index].addedNewRow = false
      if (this.SaveMultiCondition[index].ConditionFieldType === 'END') {
        this.SaveMultiCondition[index].showMinusIcon = false
      }
      // this.SaveMultiCondition.splice(index, this.SaveMultiCondition.length - index - 1)
    },
    handleConditionFieldTypeChange (condition, index) {
      this.removeConditionRow(index)
      if (condition.ConditionFieldType === 'AND' || condition.ConditionFieldType === 'OR') {
        condition.linkedTemplateGroup = null
        if (condition.addedNewRow === false) {
          this.addConditionRow(condition, index)
          this.SaveMultiCondition[index].addedNewRow = true
        }
      }
    },
    // End of Multi Condition Mapping
    clearTabindex () {
      var elements = document.getElementsByClassName('v-icon')
      for (let i = 0; i < elements.length; i++) {
        elements[i].setAttribute('tabindex', '-1')
      }
    },
    changedSate (flag) {
      this.$emit('changedSave', flag)
    },
    getTemplateGroup () {
      const data = {}
      const params = {
        company: this.$store.state.auth.user.company,
        size: 10000
      }
      const config = {
        data: data,
        params: params
      }
      this.$utils
        .callAxios(
          this.requests.getTemplateGroup.method,
          this.requests.getTemplateGroup.url,
          config
        )
        .then((res) => {
          const result = res.data
          if (result.responseCode === '200') {
            this.groupItems = res.data.groupList
          }
        })
    },
    getPageInfoText: function (headers) {
      if (headers['x-totalelements'] === 0) return '0' + ' ' + this.$t('in total')
      return `${headers['x-total-count'] * 1}` + ' ' + this.$t('in total')
    },
    getTemplateList (page) {
      const data = {}
      const params = {}
      params.page = page
      params.company = this.$store.state.auth.user.company
      const config = {
        data: data,
        params: params
      }
      // Multi Condition Mapping
      this.$utils
        .callAxios(
          this.requests.getTemplateList.method,
          this.requests.getTemplateList.url,
          config
        )
        .then((res) => {
          // const result = res.data
          if (res.data.responseCode === '200') {
            const multiConditionList = res.data.pageCondition.multiConditionList ?? []
            this.selectedGroup = res.data.pageCondition.defaultGroup
            for (let i = 0; i < multiConditionList.length; i++) {
              const reverseConSymbolMapped = Object.fromEntries(
                Object.entries(this.conSymbolMapped).map(([key, value]) => [value, key])
              )

              const mapConSymbol = (symbol) => reverseConSymbolMapped[symbol] || symbol
              const temp = {
                priority: this.newTableItems.length + 1,
                ...multiConditionList[i].multiCondition[0],
                conSymbol: mapConSymbol(multiConditionList[i].multiCondition[0].conSymbol),
                decidingField: multiConditionList[i].multiCondition[0].decidingField.toUpperCase(),
                isExpandable: multiConditionList[i].multiCondition.length > 1,
                // otherConditions: [...multiConditionList[i].multiCondition].slice(1),
                otherConditions: [...multiConditionList[i].multiCondition].slice(1).map(cond => ({
                  ...cond,
                  conSymbol: mapConSymbol(cond.conSymbol),
                  decidingField: cond.decidingField.toUpperCase()
                })),
                id: i
              }
              this.newTableItems.push(temp)
            }
            // const createdList = (res.data.conditionList ?? []).map((row, index) => {
            //   return {
            //     priority: index + 1,
            //     tartgetField: row.tartgetField,
            //     expectedValue: row.expectedValue,
            //     checkMethod: 'equal',
            //     linkedTemplateGroup: row.linkedTemplateGroup
            //   }
            // })
            // this.tableItems = createdList
            // this.selectedGroup = { groupName: res.data.pageCondition.defaultGroup }
            // Pagination
            this.pageInfoText = this.getPageInfoText(res.headers)
          }
        })
        // End of Multi Condition Mapping
    },
    async RemoveMultiRow () {
      const ok = await this.$confirm.open({
        title: 'Delete Confirmation',
        message: 'Are you sure you want to delete selected mapping condition?'
      })
      if (!ok) return
      this.newTableItems = this.newTableItems
        .filter((tableItem) => (tableItem.priority !== this.selectedRow[0].priority))
        .map((tableItem, i) => ({ ...tableItem, priority: i + 1 }))
      this.selectedRow = []
    },
    // RemoveRow () {
    //   if (this.selectedRow.length === 0) return

    //   const aliveList = []
    //   this.tableItems.map((row, index, target) => {
    //     let alive = true
    //     this.selectedRow.forEach(element => {
    //       if (row.priority === element.priority) {
    //         alive = false
    //       }
    //     })
    //     if (alive) {
    //       aliveList.push(row)
    //     }
    //   })
    //   this.tableItems = aliveList
    //   this.selectedRow = []
    //   this.tableSort()
    // },
    // tableSort () {
    //   this.tableItems = this.tableItems.map((row, index) => {
    //     return {
    //       priority: index + 1,
    //       tartgetField: row.tartgetField,
    //       expectedValue: row.expectedValue,
    //       checkMethod: 'equal',
    //       linkedTemplateGroup: row.linkedTemplateGroup
    //     }
    //   })

    //   this.changedSate(true) // 데이타 변경 되었음
    // },
    // moveRow (type) { // top , up , down  , bottom
    //   const selectArray = []
    //   let tableItemsCopy = null
    //   let tempRow = {}
    //   let shift = 0

    //   if (this.selectedRow.length === 0) return

    //   this.selectedRow.forEach(row => {
    //     selectArray.push(row.priority)
    //   })

    //   tableItemsCopy = this.tableItems.slice()

    //   if (type === 'top') {
    //     if (selectArray.indexOf(1) !== -1) { // 최상위가 포함되면
    //       return
    //     }
    //     shift = 0 - (selectArray[0] + -1)

    //     for (let x = 0; x < selectArray.length; x++) {
    //       for (let i = 0; i < selectArray[x]; i++) {
    //         if (selectArray[x] * 1 > (i + 1)) {
    //           if (i > (selectArray[x] + shift - 1)) {
    //             this.tableItems.splice(i, 1, tableItemsCopy[i - 1])
    //           }
    //         } else if (selectArray[x] * 1 === (i + 1)) {
    //           this.tableItems.splice(i, 1, tableItemsCopy[i - 1])
    //           this.tableItems.splice(i + shift, 1, tableItemsCopy[i])
    //         }
    //         if (i === (selectArray[x] - 1)) {
    //           tableItemsCopy = this.tableItems.slice()
    //         }
    //       }
    //     }
    //   } else if (type === 'up') {
    //     shift = -1
    //     if (selectArray.indexOf(1) !== -1) { // 최상위가 포함되면
    //       return
    //     }
    //     for (let i = 0; i < this.tableItems.length; i++) {
    //       if (selectArray.indexOf(this.tableItems[i].priority) !== -1) {
    //         tempRow = this.tableItems[i]
    //         this.tableItems.splice(i, 1, this.tableItems[i + shift])
    //         this.tableItems.splice(i + shift, 1, tempRow)
    //       }
    //     }
    //   } else if (type === 'down') {
    //     shift = 1
    //     if (selectArray.indexOf(this.tableItems.length) !== -1) { // 최하위가 포함되면
    //       return
    //     }
    //     for (let i = this.tableItems.length - 1; i >= 0; i--) {
    //       if (selectArray.indexOf(this.tableItems[i].priority) !== -1) {
    //         tempRow = this.tableItems[i]
    //         this.tableItems.splice(i, 1, this.tableItems[i + shift])
    //         this.tableItems.splice(i + shift, 1, tempRow)
    //       }
    //     }
    //   } else if (type === 'bottom') {
    //     if (selectArray.indexOf(this.tableItems.length) !== -1) { // 최하위가 포함되면
    //       return
    //     }

    //     shift = this.tableItems.length - (selectArray[selectArray.length - 1])
    //     for (let x = selectArray.length - 1; x >= 0; x--) {
    //       for (let i = selectArray[x] - 1; i < this.tableItems.length; i++) {
    //         if (selectArray[x] * 1 < (i + 1)) {
    //           if (i < (selectArray[x] + shift - 1)) {
    //             this.tableItems.splice(i, 1, tableItemsCopy[i + 1])
    //           }
    //         } else if (selectArray[x] * 1 === (i + 1)) {
    //           this.tableItems.splice(i, 1, tableItemsCopy[i + 1])
    //           this.tableItems.splice(i + shift, 1, tableItemsCopy[i])
    //         }
    //         if (i === (this.tableItems.length - 1)) {
    //           tableItemsCopy = this.tableItems.slice()
    //         }
    //       }
    //     }
    //   }
    //   this.tableSort()
    //   const selectedStay = []
    //   this.selectedRow.map((value) => {
    //     selectedStay.push(this.tableItems[value.priority + shift - 1])
    //   })
    //   this.selectedRow = selectedStay
    // },
    getTargetField () {
      const data = {}
      const params = { }
      // cloud 용 임시
      if (this.productionType === 'cloud') {
        params.company = this.$store.state.auth.user.company
      }
      const config = {
        data: data,
        params: params
      }
      this.$utils
        .callAxios(
          this.requests.getTargetField.method,
          this.requests.getTargetField.url,
          config
        )
        .then((res) => {
          const result = res.data
          if (result.responseCode === '200') {
            this.targetFieldItems = res.data.articleDataKeyList
            // Multi Condition Mapping
            const fields = [...this.targetFieldItems]
            fields.unshift('user-value')
            this.ConFieldCompare = fields
            // End Multi Condition Mapping
          }
        })
    },
    closeModal () {
      this.dialogSave = false
    },
    initAddPopup () {
      this.SaveCondition.tartgetField = ''
      this.SaveCondition.expectedValue = ''
      this.SaveCondition.linkedTemplateGroup = ''
      this.getTargetField()
    },
    // Multi Condition Mapping
    // move (array, fromIndex, toIndex) {
    //   const [movedItem] = array.splice(fromIndex, 1) // Remove the item from the array
    //   array.splice(toIndex, 0, movedItem) // Insert the item at the new position
    //   return array
    // },
    // moveCond (type) {
    //   if (this.selectedRow.length === 0 || this.selectedRow.length === this.newTableItems.length) return
    //   switch (type) {
    //     case 'up': { // Move items up by one position based on priority
    //       for (const obj of this.selectedRow) {
    //         const currentIndex = this.newTableItems.findIndex(item => item.priority === obj.priority)
    //         if (currentIndex > 0) {
    //           this.move(this.newTableItems, currentIndex, currentIndex - 1)
    //         }
    //       }
    //       break
    //     }
    //     case 'down':
    //     { // Move items down by one position based on priority
    //       for (let i = this.selectedRow.length - 1; i >= 0; i--) {
    //         const obj = this.selectedRow[i]
    //         const currentIndex = this.newTableItems.findIndex(item => item.priority === obj.priority)
    //         if (currentIndex < this.newTableItems.length - 1) {
    //           this.move(this.newTableItems, currentIndex, currentIndex + 1)
    //         }
    //       }
    //       break }

    //     case 'start':
    //     { // Move items to the start of the array based on priority
    //       const itemsToStart = []
    //       for (const obj of this.selectedRow) {
    //         const currentIndex = this.newTableItems.findIndex(item => item.priority === obj.priority)
    //         itemsToStart.push(...this.newTableItems.splice(currentIndex, 1)) // Remove the item from the array
    //       }
    //       this.newTableItems.unshift(...itemsToStart) // Add to the start
    //       break
    //     }
    //     case 'end':
    //     { // Move items to the end of the array based on priority
    //       const itemsToEnd = []
    //       for (const obj of this.selectedRow) {
    //         const currentIndex = this.newTableItems.findIndex(item => item.priority === obj.priority)
    //         itemsToEnd.push(...this.newTableItems.splice(currentIndex, 1)) // Remove the item from the array
    //       }
    //       this.newTableItems.push(...itemsToEnd) // Add to the end
    //       break }

    //     default:
    //       console.log('Invalid move type.')
    //       break
    //   }
    //   // After moving, update the priorities to reflect their new positions
    //   this.newTableItems = this.newTableItems.map((item, index) => ({
    //     ...item, priority: index + 1
    //   }))
    //   this.selectedRow = this.selectedRow.map(selected => {
    //     const updatedItem = this.newTableItems.find(item => item.id === selected.id)
    //     return updatedItem // Return the updated item from the newTableItems
    //   })
    //   // this.selectedRow = []
    // },
    moveCondPriority (direction) {
      if (this.selectedRow.length !== 1) return
      const selectedRow = this.selectedRow[0]
      const currentIndex = this.newTableItems.findIndex(item => item.priority === selectedRow.priority)

      if (currentIndex === -1) return // Selected row not found

      // Remove selected row from its current position
      const [movedItem] = this.newTableItems.splice(currentIndex, 1)

      switch (direction) {
        case 'start':
          this.newTableItems.unshift(movedItem)
          break

        case 'end':
          this.newTableItems.push(movedItem)
          break

        case 'up':
          if (currentIndex > 0) {
            this.newTableItems.splice(currentIndex - 1, 0, movedItem)
          } else {
            this.newTableItems.unshift(movedItem) // Already at top
          }
          break

        case 'down':
          if (currentIndex < this.newTableItems.length) {
            this.newTableItems.splice(currentIndex + 1, 0, movedItem)
          } else {
            this.newTableItems.push(movedItem) // Already at bottom
          }
          break

        default:
          console.error('Invalid move direction')
          return
      }
      this.selectedRow = [movedItem]

      // Reassign priority based on new order
      this.newTableItems.forEach((item, index) => {
        item.priority = index + 1 // Priorities are now in ascending order
      })
    },
    editCondition () {
      const res = []
      let temp = []

      for (let i = 0; i < this.SaveMultiCondition.length; i++) {
        const cond = this.SaveMultiCondition[i]
        const obj = {
          decidingField: cond.decidingField,
          conField: cond.ConditionField,
          conSymbol: cond.ConditionSymbol,
          conFieldCompare: cond.ConditionFieldCompare,
          conText: cond.ConText,
          conFieldType: cond.ConditionFieldType,
          selTemplateGroup: cond.linkedTemplateGroup
        }

        // Validation
        if (
          !commons.isValidStr(obj.conField) ||
          !commons.isValidStr(obj.conSymbol) ||
          !commons.isValidStr(obj.conFieldCompare) ||
          !commons.isValidStr(obj.conFieldType) ||
          (obj.conFieldCompare === 'user-value' && !commons.isValidStr(obj.conText)) ||
          (obj.conFieldType === 'END' && !commons.isValidStr(obj.selTemplateGroup))
        ) {
          EventBus.$emit('messageAlert', this.$t('Please provide data correctly in all fields'))
          return
        }

        temp.push(obj)

        if (obj.conFieldType === 'END') {
          res.push({ multiCondition: [...temp] })
          temp = []
        }
      }

      const editIndex = this.newTableItems.findIndex(item => item.priority === this.editingPriority)
      if (editIndex !== -1 && res.length > 0) {
        const updatedItem = {
          priority: this.editingPriority,
          ...res[0].multiCondition[0],
          id: this.newTableItems[editIndex].id,
          isExpandable: res[0].multiCondition.length > 1,
          otherConditions: [...res[0].multiCondition].slice(1)
        }
        this.newTableItems.splice(editIndex, 1, updatedItem)
      }

      // Reset state
      this.SaveMultiCondition = [{
        page: this.tapNumber,
        ConditionField: '',
        ConditionSymbol: '',
        ConditionFieldCompare: '',
        ConText: '',
        decidingField: '',
        ConditionFieldType: 'END',
        linkedTemplateGroup: '',
        addedNewRow: false,
        showMinusIcon: false
      }]
      this.dialogSave = false
      this.isEditDialog = false
      this.editingPriority = null
    },
    openEditDialog (event, { item }) {
      this.editingPriority = item.priority
      const reverseConSymbolMapped = Object.fromEntries(
        Object.entries(this.conSymbolMapped).map(([key, value]) => [value, key])
      )
      const mapConSymbol = (symbol) => reverseConSymbolMapped[symbol] || symbol
      this.dialogSave = true
      this.isEditDialog = true
      this.SaveMultiCondition = [{
        page: this.tapNumber,
        ConditionField: item.conField,
        ConditionSymbol: mapConSymbol(item.conSymbol),
        ConditionFieldCompare: item.conFieldCompare,
        ConText: item.conText,
        decidingField: item.decidingField.toUpperCase(),
        ConditionFieldType: item.conFieldType,
        linkedTemplateGroup: item.selTemplateGroup,
        addedNewRow: false,
        showMinusIcon: false
      }]

      for (const cond of item.otherConditions) {
        this.SaveMultiCondition.push({
          page: this.tapNumber,
          ConditionField: cond.conField,
          ConditionSymbol: mapConSymbol(cond.conSymbol),
          ConditionFieldCompare: cond.conFieldCompare,
          ConText: cond.conText,
          decidingField: cond.decidingField.toUpperCase(),
          ConditionFieldType: cond.conFieldType,
          linkedTemplateGroup: cond.selTemplateGroup,
          addedNewRow: false,
          showMinusIcon: false
        })
      }
    },
    openViewDialog (item) {
      console.log(item)
      const reverseConSymbolMapped = Object.fromEntries(
        Object.entries(this.conSymbolMapped).map(([key, value]) => [value, key])
      )
      const mapConSymbol = (symbol) => reverseConSymbolMapped[symbol] || symbol
      this.dialogSave = true
      this.isEditDialog = false
      this.disableDialogFields = true
      this.SaveMultiCondition = [{
        page: this.tapNumber,
        ConditionField: item.conField,
        ConditionSymbol: mapConSymbol(item.conSymbol),
        ConditionFieldCompare: item.conFieldCompare,
        ConText: item.conText,
        decidingField: item.decidingField.toUpperCase(),
        ConditionFieldType: item.conFieldType,
        linkedTemplateGroup: item.selTemplateGroup,
        addedNewRow: false,
        showMinusIcon: false
      }]

      for (const cond of item.otherConditions) {
        this.SaveMultiCondition.push({
          page: this.tapNumber,
          ConditionField: cond.conField,
          ConditionSymbol: mapConSymbol(cond.conSymbol),
          ConditionFieldCompare: cond.conFieldCompare,
          ConText: cond.conText,
          decidingField: cond.decidingField.toUpperCase(),
          ConditionFieldType: cond.conFieldType,
          linkedTemplateGroup: cond.selTemplateGroup,
          addedNewRow: false,
          showMinusIcon: false
        })
      }
    },
    addNewCondition () {
      const res = []
      let temp = []
      for (let i = 0; i < this.SaveMultiCondition.length; i++) {
        const obj = {
          decidingField: this.SaveMultiCondition[i].decidingField,
          conField: this.SaveMultiCondition[i].ConditionField,
          conSymbol: this.SaveMultiCondition[i].ConditionSymbol,
          conFieldCompare: this.SaveMultiCondition[i].ConditionFieldCompare,
          conText: this.SaveMultiCondition[i].ConText,
          conFieldType: this.SaveMultiCondition[i].ConditionFieldType,
          selTemplateGroup: this.SaveMultiCondition[i].linkedTemplateGroup
        }
        // 1. Condition Field, Condition Symbol, Condition Field Compare, Condition Field Type Should be a valid string, should not be undefined or null
        // 2. if Condition Field Compare, selected value is USER VALUE than Condition Text should be a valid String
        // 3. if Condition Field Type selected value is END than Template Group should be selected or should be a valid String
        if (!commons.isValidStr(obj.conField) || !commons.isValidStr(obj.conSymbol) || !commons.isValidStr(obj.conFieldCompare) || !commons.isValidStr(obj.conFieldType) || (obj.conFieldCompare === 'user-value' && !commons.isValidStr(obj.conText)) || (obj.conFieldType === 'END' && !commons.isValidStr(obj.selTemplateGroup))) {
          EventBus.$emit('messageAlert', this.$t('Please provide data correctly in all fields'))
          return
        }
        temp.push(obj)
        if (this.SaveMultiCondition[i].ConditionFieldType === 'END') {
          res.push({ multiCondition: [...temp] })
          // this.saveReqBody.push({ multiCondition: [...temp] })
          temp = []
        }
      }
      for (let i = 0; i < res.length; i++) {
        const temp = {
          priority: this.newTableItems.length + 1,
          ...res[i].multiCondition[0],
          id: i,
          isExpandable: res[i].multiCondition.length > 1,
          otherConditions: [...res[i].multiCondition].slice(1)
        }
        this.newTableItems.push(temp)
      }
      this.SaveMultiCondition = [{
        page: this.tapNumber,
        ConditionField: '',
        ConditionSymbol: '',
        ConditionFieldCompare: '',
        ConText: '',
        decidingField: '',
        ConditionFieldType: 'END',
        linkedTemplateGroup: '',
        addedNewRow: false,
        showMinusIcon: false
      }]
      // if (this.SaveCondition.tartgetField === '') {
      //   EventBus.$emit('messageAlert', this.$t('Input the tartget data'))
      //   this.$refs.tartgetField.focus()
      //   return
      // }
      // if (this.SaveCondition.expectedValue === '') {
      //   EventBus.$emit('messageAlert', this.$t('Input the expectedValue data'))
      //   this.$refs.expectedValue.focus()
      //   return
      // }
      // if (this.SaveCondition.linkedTemplateGroup === '') {
      //   EventBus.$emit('messageAlert', this.$t('Input the  linkedTemplateGroup data'))
      //   this.$refs.linkedTemplateGroup.focus()
      //   return
      // }
      // // add List
      // this.tableItems.push(
      //   {
      //     priority: this.tableItems.length + 1,
      //     tartgetField: this.SaveCondition.tartgetField,
      //     expectedValue: this.SaveCondition.expectedValue,
      //     checkMethod: 'equal',
      //     linkedTemplateGroup: this.SaveCondition.linkedTemplateGroup
      //   }
      // )
      this.dialogSave = false
      // this.changedSate(true) // 데이타 변경 되었음 (Data has changed)
    },
    createSaveReqBody () {
      this.saveReqBody = []
      for (const newTableItem of this.newTableItems) {
        const multiConditionArr = [
          {
            decidingField: newTableItem.decidingField,
            conField: newTableItem.conField,
            conSymbol: this.conSymbolMapped[newTableItem.conSymbol],
            conFieldCompare: newTableItem.conFieldCompare,
            conText: newTableItem.conText,
            conFieldType: newTableItem.conFieldType,
            selTemplateGroup: newTableItem.selTemplateGroup
          }
        ]
        if (newTableItem.otherConditions.length > 0) {
          for (const otherCond of newTableItem.otherConditions) {
            multiConditionArr.push(
              {
                decidingField: otherCond.decidingField,
                conField: otherCond.conField,
                conSymbol: this.conSymbolMapped[otherCond.conSymbol],
                conFieldCompare: otherCond.conFieldCompare,
                conText: otherCond.conText,
                conFieldType: otherCond.conFieldType,
                selTemplateGroup: otherCond.selTemplateGroup
              }
            )
          }
        }
        this.saveReqBody.push({ multiCondition: multiConditionArr })
      }
    },
    multiConSave () {
      const selectedGroupValue = this.groupItems.filter((item) => {
        if (this.selectedGroup === item.groupName) return item
      })

      if (!commons.notEmpty(selectedGroupValue)) {
        EventBus.$emit('messageAlert', this.$t('Template group not exists. Please change the default template group'))
        return
      }
      this.createSaveReqBody()
      const data = {}
      const params = {}
      params.company = this.$store.state.auth.user.company
      params.page = this.tapNumber

      data.defaultGroup = this.selectedGroup
      data.multiConditionList = this.saveReqBody
      data.page = this.tapNumber
      const config = {
        params: params
      }
      this.$utils
        .callAxiosWithBody(
          this.requests.getTemplateSave.method,
          this.requests.getTemplateSave.url,
          data,
          config
        )
        .then((res) => {
          const result = res.data
          if (result.responseCode === '200') {
            EventBus.$emit('messageAlert', this.$t('Saved successfully'))
            this.dialogSave = false
            this.changedSate(false) // 데이타 변경상태 클리어
          } else {
            EventBus.$emit('messageAlert', this.$t(result.responseMessage))
          }
        })
    }
    // End of Multi Condition Mapping
    // Save () {
    //   // selectedGroup값이 groupItems에 포함 되어 있는지 확인
    //   const selectedGroupValue = this.groupItems.filter((item) => {
    //     if (this.selectedGroup === item.groupName) return item
    //   })

    //   if (!commons.notEmpty(selectedGroupValue)) {
    //     EventBus.$emit('messageAlert', this.$t('Template group not exists. Please change the default template group'))
    //     return
    //   }
    //   const data = {}
    //   const params = { }
    //   params.company = this.$store.state.auth.user.company
    //   params.page = this.tapNumber

    //   data.defaultGroup = this.selectedGroup
    //   data.conditionList = this.tableItems
    //   const config = {
    //     params: params
    //   }
    //   this.$utils
    //     .callAxiosWithBody(
    //       this.requests.getTemplateSave.method,
    //       this.requests.getTemplateSave.url,
    //       data,
    //       config
    //     )
    //     .then((res) => {
    //       const result = res.data

    //       if (result.responseCode === '200') {
    //         EventBus.$emit('messageAlert', this.$t('Saved successfully'))
    //         this.dialogSave = false
    //         this.changedSate(false) // 데이타 변경상태 클리어
    //       } else {
    //         EventBus.$emit('messageAlert', this.$t(result.responseMessage))
    //       }
    //     })
    // }
  },
  mounted () { // init
    this.getTemplateGroup()
    this.getTemplateList(this.tapNumber)
  },
  data () {
    return {
      // cloud 용 임시
      productionType: process.env.VUE_APP_PRODUCTION_TYPE,
      isEditDialog: false,
      editingPriority: null,
      selectedRow: [],
      search: '',
      page: 1,
      pageCount: 0,
      dialogSave: false,
      deleteDisabled: true,
      pageInfoText: '',
      SaveCondition: {
        page: this.tapNumber,
        tartgetField: '',
        checkMethod: '',
        expectedValue: '',
        linkedTemplateGroup: ''
      },
      // Multi Condition Mapping
      SaveMultiCondition: [{
        page: this.tapNumber,
        ConditionField: '',
        ConditionSymbol: '',
        ConditionFieldCompare: '',
        ConText: '',
        decidingField: '',
        ConditionFieldType: 'END',
        linkedTemplateGroup: '',
        addedNewRow: false,
        showMinusIcon: false
      }],
      expanded: [],
      disableDialogFields: false,
      newTemplateMappingHeaders: [
        { text: this.$t('PRIORITY'), value: 'priority', sortable: false, width: '8%' },
        { text: this.$t('CON FIELD'), value: 'conField', sortable: false, width: '13.6%' },
        { text: this.$t('CON SYMBOL'), value: 'conSymbol', sortable: false, width: '10%' },
        { text: this.$t('CON FIELD COMPARE'), value: 'conFieldCompare', sortable: false, width: '13.6%' },
        { text: this.$t('CON TEXT'), value: 'conText', sortable: false, width: '13.6%' },
        { text: this.$t('DECIDING FIELD'), value: 'decidingField', sortable: false, width: '13.6%' },
        { text: this.$t('CON TYPE'), value: 'conFieldType', sortable: false, width: '13.6%' },
        { text: this.$t('LINKED TEMPLATE GROUP'), value: 'selTemplateGroup', sortable: false, width: '15.6%' },
        { text: '', value: 'data-table-expand' }
      ],
      saveReqBody: [],
      newTableItems: [],
      // end Multi Condition Mapping
      requests: {
        getTemplateGroup: {
          method: 'get',
          url: '/api/common/templates/mapping/group'
        },
        getTemplateList: {
          method: 'get',
          url: '/api/common/templates/mapping/condition'
        },
        getTemplateSave: {
          method: 'post',
          url: '/api/common/templates/mapping/condition'
        },
        getTargetField: {
          method: 'get',
          url: '/api/common/articles/data'
        }
      },
      selectedGroup: {},
      groupItems: [],
      targetFieldItems: [],
      tableItems: [],
      // Multi Condition Part
      ConSymbol: ['=', '!=', '>', '<', '>=', '<=', 'contains', 'start-with', 'end-with', 'string length =', 'string length !=', 'string length >', 'string length <', 'string length >=', 'string length <='],
      conSymbolMapped: {
        '=': 'equal',
        '!=': 'not-equal',
        '<': 'less-than',
        '>': 'more-than',
        '<=': 'less-than-equal',
        '>=': 'more-than-equal',
        contains: 'contains',
        'start-with': 'start-with',
        'end-with': 'end-with',
        'string length =': 'length-equal',
        'string length !=': 'length-not-equal',
        'string length <': 'length-less-than',
        'string length >': 'length-more-than',
        'string length <=': 'length-less-than-equal',
        'string length >=': 'length-more-than-equal'
      },
      ConFieldCompare: [],
      ConText: '',
      ConFieldType: ['END', 'AND', 'OR'],
      SelTempGroup: '',
      decidingField: ['ID', 'NAME', 'DATA']
      // End
    }
  }
}
</script>
<style scoped>
  .groupList{width:53%;}
  .selectedGroup{width:43.07%;}
  .borderBox{padding:20px; border:1px solid #ececec;}
  .pageTab{border-top-left-radius:5px; border-top-right-radius:5px; color:#fff; background:#2f3b4c; font-size:var(--font15); font-weight:700; text-align:center;}
  .mapping-search{padding:8px; background:#2f3b4c;}
  .mapping-search .innerBox{width:400px;}
  .mapping-search p{font-size:var(--font13); color:#fff; font-weight:700; letter-spacing: 0,05em;}
</style>
<style>
    /* Multi Condition Mapping */
    .expanded-td {
      padding: 0 16px;
      transition: height 0.2s cubic-bezier(0.4, 0, 0.6, 1);
      font-size: 0.875rem;
      height: 48px;
      display: flex;
      align-items: center;
    }
    /* End of Multi Condition Mapping */
</style>
